/* eslint-disable @typescript-eslint/naming-convention */
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'
// Choosing not to lazy load these component
import CheckInSurveyPage from '../CheckInSurvey'
import NeedsAssessmentPage from '../NeedsAssessment'
import OnboardingPage from '../Onboarding'
import IntakePage from '../IntakeFlow'

const Welcome = lazy(() => import('./Welcome'))

export default {
  path: '/welcome',
  exact: true,
  Component: Welcome,
  access: 'USER',
}

export const NeedsAssessment = {
  path: '/get-started',
  exact: true,
  Component: WithPermission(NeedsAssessmentPage, ['page:get_started'], true),
  access: 'USER',
}

export const CheckInSurvey = {
  path: '/check-in',
  exact: true,
  Component: WithPermission(CheckInSurveyPage, ['page:get_started'], true),
  access: 'USER',
}

export const OnBoarding = {
  path: '/on-boarding',
  exact: true,
  Component: WithPermission(OnboardingPage, ['page:get_started'], true),
  access: 'USER',
}

export const Intake = {
  path: '/intake',
  exact: true,
  Component: WithPermission(IntakePage, ['page:get_started'], true),
  access: 'USER',
}
